/*
  Thomas' Custom Code — Product Media Fail-Safe
  ------------------------------------------------------------
  Purpose:
  - Forces first gallery image visible if JS hydration lags.
  - Removes hidden masks that keep thumbnails gray.
  - Re-paints <img> elements if they failed to draw.
  - Eager-loads primary images to prevent lazy timing bugs.
*/

(function () {
  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    console.debug('Thomas’ Custom Code: Media fail-safe initialized');

    /* 1️⃣  Ensure at least one visible/active slide */
    document.querySelectorAll('[id^="GalleryViewer"]').forEach(function (viewer) {
      const slides = viewer.querySelectorAll('.product__media-item');
      if (!slides.length) return;
      const active = viewer.querySelector('.product__media-item.is-active');
      if (!active) {
        slides[0].classList.add('is-active');
      }
    });

    /* 2️⃣  Unhide any elements stuck behind [hidden] */
    document.querySelectorAll('.product-media-container [hidden]').forEach(function (el) {
      el.removeAttribute('hidden');
    });

    /* 3️⃣  Re-paint any broken <img> tags */
    document.querySelectorAll('.product__media img, .thumbnail-list img').forEach(function (img) {
      // If browser marked complete but nothing rendered
      if (img.complete && img.naturalWidth === 0) {
        const s = img.currentSrc || img.src;
        if (s) img.src = s;
      }
      // Force eager load for main product images
      if (img.closest('.product__media')) {
        img.loading = 'eager';
        img.style.opacity = '1';
        img.style.visibility = 'visible';
      }
    });

    /* 4️⃣  Scroll the active image into view (just in case) */
    document.querySelectorAll('.product__media-item.is-active').forEach(function (active) {
      const parent = active.parentElement;
      if (parent && typeof parent.scrollTo === 'function') {
        parent.scrollTo({ left: active.offsetLeft });
      }
    });

    /* 5️⃣  Log completion (optional) */
    console.debug('Thomas’ Custom Code: Media fail-safe completed');
  });
})();
